import ERROR from '../Constants/Fields';
var ProfileFieldsHelper = /** @class */ (function () {
    function ProfileFieldsHelper() {
    }
    ProfileFieldsHelper.IBANCorrect = function (str) {
        if (!this.IBAN_REGEX.test(str)) {
            return ERROR.IBAN_REGEX_ERROR;
        }
        else {
            return ERROR.IBAN_CORRECT;
        }
    };
    // soit 8 soit 11
    ProfileFieldsHelper.BICCorrect = function (str) {
        if (str.length != 11 && str.length != 8) {
            return ERROR.BIC_LENGTH_ERROR;
        }
        else {
            return ERROR.BIC_CORRECT;
        }
    };
    ProfileFieldsHelper.verifyEmail = function (email) {
        if (email == null || email.length == this.ZERO_LENGTH) {
            return ERROR.EMAIL_NULL_OR_EMPTY;
        }
        else if (!(this.EMAIL_REGEX.test(email))) {
            return ERROR.EMAIL_REGEX;
        }
        else {
            return ERROR.EMAIL_CORRECT;
        }
    };
    ProfileFieldsHelper.isFilled = function (str) {
        if (str == undefined || str == "" || str == null) {
            return ERROR.FILLED_ERROR;
        }
        else {
            return ERROR.FILLED_CORRECT;
        }
    };
    ProfileFieldsHelper.verifyPassword = function (password) {
        if (password == null || password.length == this.ZERO_LENGTH) {
            return ERROR.PASSWORD_NULL_OR_EMPTY;
        }
        else if (password.length > this.MAXIMUM_LENGTH) {
            return ERROR.PASSWORD_MAXIMUM_LENGTH;
        }
        if (password.length < this.PASSWORD_MINIMUM_LENGTH) {
            return ERROR.PASSWORD_MINIMUM_LENGTH;
        }
        else
            return ERROR.PASSWORD_CORRECT;
    };
    ProfileFieldsHelper.verifyPasswordAdvanced = function (password) {
        var errorcode = this.verifyPassword(password);
        if (errorcode == ERROR.PASSWORD_CORRECT) {
            if (!this.hasAtLeastOneLowercase(password)) {
                return ERROR.PASSWORD_AT_LEAST_ONE_LOWERCASE;
            }
            if (!this.hasAtleastOneUppercase(password)) {
                return ERROR.PASSWORD_AT_LEAST_ONE_UPPERCASE;
            }
            if (!this.hasAtLeastOneNumber(password)) {
                return ERROR.PASSWORD_AT_LEAST_ONE_NUMBER;
            }
            if (!this.hasAtLeastOneSpecialChar(password)) {
                return ERROR.PASSWORD_AT_LEAST_ONE_SPECIAL_CHARACTER;
            }
            return ERROR.PASSWORD_CORRECT;
        }
        return errorcode;
    };
    ProfileFieldsHelper.verifyTextFields = function (text) {
        if (text == null || text.length == this.ZERO_LENGTH) {
            return ERROR.FIELDS_NULL_OR_EMPTY;
        }
        else if (text.length > this.MAXIMUM_LENGTH) {
            return ERROR.FIELDS_MAXIMUM_MENGTH;
        }
        else {
            return ERROR.FIELDS_CORRECT;
        }
    };
    ProfileFieldsHelper.verifyOnlyNumber = function (text) {
        if (!this.NUMBER_REGEX.test(text)) {
            return ERROR.ONLY_NUMBERS_ERROR;
        }
        return ERROR.ONLY_NUMBERS;
    };
    ProfileFieldsHelper.hasAtLeastOneLowercase = function (str) {
        return str.toUpperCase() !== str;
    };
    ProfileFieldsHelper.hasAtleastOneUppercase = function (str) {
        return str.toLowerCase() !== str;
    };
    ProfileFieldsHelper.hasAtLeastOneNumber = function (str) {
        return /\d/.test(str);
    };
    ProfileFieldsHelper.hasAtLeastOneSpecialChar = function (str) {
        var regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        return regex.test(str);
    };
    //COMMON
    ProfileFieldsHelper.ZERO_LENGTH = 0;
    ProfileFieldsHelper.MAXIMUM_LENGTH = 100;
    //EMAIL
    ProfileFieldsHelper.EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //NUMBER
    ProfileFieldsHelper.NUMBER_REGEX = /^[0-9]*$/;
    //DOUBLE
    //public static readonly DOUBLE_REGEX = /\d{1,2}[\,\.]{1}\d{1,2}/;
    //IBAN
    //FIXME: Need to be more strict.
    //Because when you enter BE with 28 characters it will work.
    //And BE need to be only 16 I think.
    ProfileFieldsHelper.IBAN_REGEX = /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/;
    //DATE
    ProfileFieldsHelper.DATE_REGEX = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
    //PASSWORD
    ProfileFieldsHelper.PASSWORD_MINIMUM_LENGTH = 8;
    return ProfileFieldsHelper;
}());
export default ProfileFieldsHelper;
